export enum CompanyEnum {
    RUEIL = 'Mairie Rueil-Malmaison',
    IFPEN = 'IFPEN'
}

export enum CompanyImgEnum {
    IFPEN_IMG = '/content/images/company/ifpen_1.jpg',
    RUEIL_IMG = '/content/images/company/mairie-rueil-malmaison.png'
}
